var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "7daa9d73b9f24ccb2c79791c8a03d57b.png",
    width: 312,
    height: 600
});